import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { http, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMsg("No verification token provided.");
      return;
    }
    http.post("/auth/verify-email", { token })
      .then((r) => { setState("ok"); setMsg(r.data.message); })
      .catch((e) => { setState("error"); setMsg(apiError(e)); });
  }, [token]);

  return (
    <AuthShell>
      <div className="text-center" data-testid="verify-email-panel">
        {state === "loading" && (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-[#D4AF37] mx-auto" />
            <h2 className="font-display text-2xl font-bold text-[#0B132B] mt-5">Verifying your email…</h2>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-emerald-500 mx-auto" />
            <h2 className="font-display text-2xl font-bold text-[#0B132B] mt-5">Email verified!</h2>
            <p className="text-slate-500 text-sm mt-2">{msg}</p>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-14 h-14 text-rose-500 mx-auto" />
            <h2 className="font-display text-2xl font-bold text-[#0B132B] mt-5">Verification failed</h2>
            <p className="text-slate-500 text-sm mt-2">{msg}</p>
          </>
        )}
        <Link to="/">
          <Button className="mt-6 bg-[#0B132B] hover:bg-[#1C2541] h-11 px-8" data-testid="verify-continue-button">Continue to app</Button>
        </Link>
      </div>
    </AuthShell>
  );
}
